// Reboot URLs for different environments
const PROD_REBOOT_URL = "https://axibtdbnwf7.prod1.rbt.cloud:9991";
const STAGING_REBOOT_URL = "https://acczhr2wb7t.prod1.rbt.cloud:9991";

/**
 * Reboot should run only in client side code (tauri or web).
 *
 * Set `REBOOT_URL=http://localhost:9991` to connect to a local reboot server.
 *
 * Set `DISABLE_REBOOT` to any value to disable reboot entirely from the local runtime.
 */
export const getRebootUrl = (appEnv: string, isInIframe: boolean): string | null => {
	// Check if Reboot is explicitly disabled
	if (
		typeof process.env["DISABLE_REBOOT"] !== "undefined" &&
		process.env["DISABLE_REBOOT"] !== ""
	) {
		console.warn("Reboot is disabled via DISABLE_REBOOT.");
		return "";
	}

	// Check for explicit URL override
	if (process.env["REBOOT_URL"] !== undefined) {
		return process.env["REBOOT_URL"] ?? "";
	}

	// Handle iframe case
	if (isInIframe) {
		// HACK!!! for some reason iframe does not get PROCESS ENV!!!
		const hostname = typeof window !== "undefined" ? window.location.hostname : "";
		if (hostname.includes("iframe.moment.dev")) {
			return PROD_REBOOT_URL;
		}
		return STAGING_REBOOT_URL;
	}

	// Environment-based URL selection
	switch (appEnv) {
		case "local":
			return STAGING_REBOOT_URL;
		case "staging":
			return STAGING_REBOOT_URL;
		case "production":
			return PROD_REBOOT_URL;
		default:
			console.warn(`WARNING: no reboot url defined, not connecting to reboot`);
			return "";
	}
};
